import { message } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';

import { ErrorMessage } from '@/models';

// Global message API instance - will be set by MessageProvider component
let messageApi: MessageInstance | null = null;

/**
 * Sets the global message API instance.
 * This is called by MessageProvider component.
 */
export function setMessageApi(api: MessageInstance) {
  messageApi = api;
}

/**
 * Gets the global message API instance.
 * Falls back to static methods if instance is not available yet.
 */
function getMessageApi(): MessageInstance {
  if (messageApi) {
    return messageApi;
  }
  // Fallback to static methods if instance not initialized yet
  // This should rarely happen, but provides a safety net
  return message;
}

export function showMessage(type: 'success' | 'error', content: string) {
  const api = getMessageApi();
  const duration = content === ErrorMessage.EMAIL_VALIDATION_ERROR ? 15 : 5;
  void api.open({ type, content, duration: duration });
}

/***
 * @example onError: (error) => {
 showMessage('error', t(showErrorMessage(error as string)));
 },
 */
export function showErrorMessage(error: string) {
  return error in ErrorMessage ? `errorCodes:${error}` : 'forms:failed';
}
